import { render } from "./BattlesFilterMode.vue?vue&type=template&id=1577ae64&scoped=true"
import script from "./BattlesFilterMode.vue?vue&type=script&lang=js"
export * from "./BattlesFilterMode.vue?vue&type=script&lang=js"

import "./BattlesFilterMode.vue?vue&type=style&index=0&id=1577ae64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1577ae64"]])

export default __exports__